import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isPeopleAreaPath, writeReturnList } from "@/lib/people-list-return";

/**
 * Forgets the tab's People return list once it leaves the People area (see readReturnList), so a
 * record opened later from elsewhere never inherits an old list's filters, selection or scroll.
 * It only sees in-app navigation, and sits outside the organization provider: a list from before a
 * full-page load, or from another organization, is refused by readReturnList.
 */
export function PeopleReturnListTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isPeopleAreaPath(pathname)) writeReturnList(null);
  }, [pathname]);
  return null;
}
